export type PaymentFrequency = 'annually' | 'semi-annually' | 'quarterly' | 'monthly' | 'bi-weekly' | 'weekly';
export type LoanState = 'active' | 'paid_off' | 'defaulted' | 'pending';

export interface Loan {
    id: number;
    bank_id: number;
    contact_id: number;
    loan_type: 'new' | 'mid-life' | null;
    name: string;
    amount: number;
    interest_rate: number;
    term: number; // Number of payments based on frequency
    payment: number | null;
    frequency: PaymentFrequency;
    close_date: Date | string;
    start_payment_date: Date | string;
    next_payment_number: number | null;
    next_payment_date: Date | string;
    next_principal: number | null;
    next_interest: number | null;
    remaining_balance: number | null;
    mid_life_balance: number | null;
    mid_life_date: Date | string;
    late_fee: number | null;
    grace_period: number | null;
    state: LoanState;
}

export const InitLoan: Loan = {
    id: 0,
    bank_id: 0,
    contact_id: 0,
    loan_type: null,
    name: '',
    amount: 0,
    interest_rate: 0,
    term: 0,
    payment: null,
    frequency: 'monthly',
    close_date: new Date(),
    start_payment_date: new Date(),
    next_payment_number: null,
    next_payment_date: new Date(),
    next_principal: null,
    next_interest: null,
    remaining_balance: null,
    mid_life_balance: null,
    mid_life_date: new Date(),
    late_fee: null,
    grace_period: null,
    state: 'pending'
};
